import { getAge } from '@/tools/getAgeFromBirthday';
import { ChildData, InitChildData } from './types';

import {
  canGetCertData,
  undefinedCertData,
  accountCertData,
  financeCertData,
  statementCertData,
} from './utils';

const parser = (data: InitChildData): ChildData => {
  const { birthday, certificate_type } = data;
  const age = getAge(birthday);
  const notConfirmed = certificate_type === 'undefined';
  const isApproved = data.is_approved;

  if (age < 5 || age > 17) return { age };
  if (!certificate_type) return canGetCertData(data);
  if (notConfirmed && !isApproved) return undefinedCertData(data);
  if (notConfirmed && isApproved) return statementCertData(data);
  if (certificate_type === 'account') return accountCertData(data);
  if (certificate_type === 'finance') return financeCertData(data);

  return {
    ...data,
  };
};

const parseChildrenService = {
  parser,
};

export default parseChildrenService;



// WEBPACK FOOTER //
// ./src/services/pfdod/pfdodService.ts